export default class SummaryCtrl {

	constructor ($scope, WorkPlanModalSrv, $stateParams, $mdDialog, $interval, $uiGridConstants, i18nService, uiGridTreeViewConstants,
		$http, $window, $cookies, Validations, WorkPlanSrv, GlobalConfig, ReviewSrv, ngNotify, $state, LOCAL_ENV_CONSTANT) {
		// CONSTANTS

		const summaryVm = this
		const currentStage = $stateParams.stage
		const user = JSON.parse($cookies.get('currentUser'))
		const roleId = +$cookies.get('hasRoleId')
		const stages = GlobalConfig.workplanStagesNames

		const inApproval = Validations.inApproval(currentStage)
		const inEvaluation = Validations.inEvaluation(currentStage)
		const inReviewExecution = Validations.inReviewExecution(currentStage) 

		$scope.STATIC_SERVER_DOMAIN = LOCAL_ENV_CONSTANT.STATIC_IMAGE_URL

		summaryVm.inReview = Validations.inReview(currentStage)
		summaryVm.inApproval = inApproval
		summaryVm.inExecution = Validations.inExecution(currentStage)
		summaryVm.inEvaluation = inEvaluation
		summaryVm.inReviewExecution = inReviewExecution
		summaryVm.textStage = ''
		summaryVm.toReviewedReject = 0
		summaryVm.selfEvaluation = 0
		summaryVm.isFeedback = false
		summaryVm.teacherId = $stateParams.teacherId
		summaryVm.workplanId = $stateParams.workplanId
		summaryVm.headerPage = { teacherName: $stateParams.name }
		summaryVm.headerModal = {}
		summaryVm.executionFinish = 1
		summaryVm.evaluationFinish = 1
		summaryVm.approvedFinish = 1
		summaryVm.reviewedFinish = 1
		summaryVm.executionReviewedFinished = 1
		summaryVm.feedback = 1
		summaryVm.isState = 1
		summaryVm.planningFinish = 1
		i18nService.setCurrentLang('es')

		summaryVm.showModal = showModal
		summaryVm.showModalFeedback = showModalFeedback
		summaryVm.showWarning = showWarning
		summaryVm.showEndStageButton = showEndStageButton
		summaryVm.isReviewerApprover = false
		summaryVm.textStageUnified = ''
		summaryVm.isFinishedButtonDisabled = true
		summaryVm.showFinishButton = true
		summaryVm.approvalOnwards = inApproval || inReviewExecution || inEvaluation
		summaryVm.reviewExecutionOnwards = inReviewExecution || inEvaluation

		summaryVm.reflexionesDePortafolioEvidenciasModel = reflexionesDePortafolioEvidenciasModel
		summaryVm.showResumen = false
		summaryVm.hours_planned_detail = 0
		summaryVm.hours_executed_detail = 0

		activate()

		function activate () {
			summaryVm.textStage = stages[currentStage]

			if (roleId === GlobalConfig.userRolesIds.workPlanAdmin ||
          roleId === GlobalConfig.userRolesIds.unitAdmin ||
          roleId === GlobalConfig.userRolesIds.gerencialConsultant) {
				summaryVm.showFinishButton = false
			}

			if (GlobalConfig.userRolesIds.approver == roleId && inEvaluation == true) {
				summaryVm.showResumen = true
			} else {
				summaryVm.showResumen = false
			}

			getTeacherInfo().then((promise) => {
				getGeneralsWorkplan().then((promise) => {
					summaryVm.headerModal = setHeader()

					if (summaryVm.inReview && GlobalConfig.userRolesIds.reviewer == roleId) {
						isReviewerAndApprover().then((promise) => {
							getFeedback().then((promise) => {
								summaryVm.isFinishedButtonDisabled = isStageFinished()
							})
						})
					}

					if (summaryVm.inApproval && GlobalConfig.userRolesIds.approver == roleId) {
						setHeaderApproval().then((promise) => {
							summaryVm.isFinishedButtonDisabled = isStageFinished() || summaryVm.isState === 2
						})
					}

					if (summaryVm.inEvaluation && GlobalConfig.userRolesIds.approver == roleId) {
						setHeaderEvaluation().then((promise) => {
							summaryVm.isFinishedButtonDisabled = isStageFinished()
						})
					}

					if (summaryVm.inReviewExecution && GlobalConfig.userRolesIds.reviewer == roleId) {
						setReviewExecutionEvaluation().then((promise) => {
							isReviewerAndApprover().then((promise) => {
								summaryVm.isFinishedButtonDisabled = isStageFinished()
							})
						})
					}
				})
			})
		}

		function isReviewerAndApprover() {
			const header = {
				teacherId : summaryVm.teacherId,
				reviewerId: user.id,
				workplanId: summaryVm.workplanId,
			}

			return WorkPlanSrv.summary.checkReviewerApprover(header).$promise.then(dataReturn => {
				if (dataReturn.status) {
					summaryVm.isReviewerApprover = dataReturn.isReviewerApprover

					if (summaryVm.inReview && summaryVm.isReviewerApprover) {
						summaryVm.textStageUnified = 'revisión y aprobación'
 
						return setHeaderApproval()
					} else if (summaryVm.inReviewExecution && summaryVm.isReviewerApprover) {
						summaryVm.textStageUnified = 'revisión ejecución y evaluación'
						summaryVm.showResumen = true

						return setHeaderEvaluation()
					}
				}
			})
		}
		function getFeedback () {
			let post = {
				teacherId : summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
			}

			return WorkPlanSrv.getFeedbackReviewedRejectGeneral.get(post).$promise.then(
				dataReturn => {
					if (dataReturn.status) {
						let now = moment(new Date()).format('YYYY-MM-DD')
						let endPlanning = moment(dataReturn.data[0].datePlanning).format('YYYY-MM-DD')

						if (now <= endPlanning) {
							summaryVm.isFeedback = true
						}
					}
				},
				data => {
					console.log(data)
				},
			)
		}

		function getTeacherInfo () {
			let params = {
				teacherId : summaryVm.workplanId,
				workplanId: summaryVm.teacherId,
			}

			return WorkPlanSrv.summary.getTeacherData(params).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio, status:', response.status)
				} else {
					summaryVm.headerPage = Object.assign(summaryVm.headerPage, response.data[0] || {})
				}
			}, (err) => {
				ngNotify.set('Imposible conectar con el servicio', err)
			})
		}

		// grid con árbol
		$scope.gridOptions = {
			enableGridMenu                 : true,
			exporterMenuPdf                : false,
			exporterCsvColumnSeparator     : ';',
			exporterOlderExcelCompatibility: true,
			gridMenuShowHideColumns        : false,
			enableSorting                  : true,
			enableFiltering                : true,
			expandableRowTemplate          : 'subgrid',
			enableScrollbars               : true,
			expandableRowHeight            : 150,
			columnDefs                     : [
				{ name        : 'Submódulo',
					displayName : 'Submódulo',
					width       : '15%',
					field       : 'ds_submodule',
					enableHiding: false,
					cellTemplate: '<div class="ui-grid-cell-contents"> <span><strong>{{row.entity.ds_submodule}}' +
                            '<md-tooltip md-direction="top" class="custom-tooltip">' +
                            '{{row.entity.ds_submodule}}' +
                            '</md-tooltip>' +
                        '</strong></span></div>',
					filter: {
						condition: function (searchTerm, cellValue, row, column) {
							switch (row.entity.$$treeLevel) {

							case 0:
								cellValue = row.entity.ds_submodule
								break
							case 1:
								cellValue = row.treeNode.parentRow.entity.ds_submodule
								break
							default:
								cellValue = row.treeNode.parentRow.treeNode.parentRow.entity.ds_submodule
								break
							
							}

							let expr = new RegExp(searchTerm, 'i')

							return !!cellValue.match(expr)
						},
					},
				},
				{ name        : 'Tipo actividad',
					displayName : 'Tipo actividad',
					field       : 'ds_activity_type',
					enableHiding: false,
					cellTemplate: '<div class="ui-grid-cell-contents"> <span><strong>{{row.entity.ds_activity_type}}' +
                            '<md-tooltip md-direction="top" class="custom-tooltip">' +
                            '{{row.entity.ds_activity_type}}' +
                            '</md-tooltip>' +
                        '</strong></span></div>',
					filter: {
						condition: function (searchTerm, cellValue, row, column) {
							switch (row.entity.$$treeLevel) {

							case 0:
								cellValue = row.treeNode.children
									.map(child => child.row.entity.ds_activity_type)
									.join(',')
								break
							case 1:
								cellValue = row.entity.ds_activity_type
								break
							default:
								cellValue = row.treeNode.parentRow.entity.ds_activity_type
								break
							
							}

							let expr = new RegExp(searchTerm, 'i')

							return !!cellValue.match(expr)
						},
					},
				},
				{ name        : 'Actividad',
					displayName : 'Actividad',
					field       : 'ds_activity',
					width       : 200,
					enableHiding: false,
					cellTemplate: '<div class="ui-grid-cell-contents"> <span>{{row.entity.ds_activity}}' +
                            '<md-tooltip md-direction="top" class="custom-tooltip">' +
                            '{{row.entity.ds_activity}}' +
                            '</md-tooltip>' +
                        '</span></div>',
				},
				{
					name        : 'En seguimiento',
					displayName : 'En seguimiento',
					field       : 'is_strategic_tracing',
					width       : '8%',
					enableHiding: false,
					cellTemplate: '<div class="text-center ui-grid-cell-contents">' +
                            '<a ng-if="row.entity.isStrategicTracing == 1" href="#"><i class="icon mdi-image-remove-red-eye text-success i-20 p-h-md"></i></a>' +
                        '</div>',
					enableFiltering : false,
					enableColumnMenu: false,
				},
				{
					name        : 'Estado',
					displayName : 'Estado',
					field       : 'status',
					width       : '7%',
					enableHiding: false,
					cellTemplate:
            `<div class="text-center ui-grid-cell-contents">
              <a ng-if="(row.entity.isReviewed == 1 && row.entity.inReview) ||
                        (row.entity.isApproved  == 1 && row.entity.inApproval) ||
                        (row.entity.isExecution == 1 && row.entity.inReviewExecution) ||
                        (row.entity.isAccept == 1 && row.entity.inEvaluation)"
              href="#">
                <i class="icon mdi-action-thumb-up text-primary i-20 p-h-md"></i></a>
              <a ng-if="(row.entity.isReviewed == 0 && row.entity.inReview) ||
                        (row.entity.isApproved  == 0 && row.entity.inApproval) ||
                        (row.entity.isExecution == 0 && row.entity.inReviewExecution) ||
                        (row.entity.isAccept == 0 && row.entity.inEvaluation)"
              href="#">
                <i class="icon mdi-action-thumb-down text-danger i-20 p-h-md"></i></a>
             </div>`,
					enableFiltering : false,
					enableColumnMenu: false,
				},
				{ name: 'Horas plan.', displayName: 'Horas planeadas', field: 'total_horas', width: '8%', enableHiding: false },
				{ name: 'Porcentaje horas plan.', displayName: 'Porcentaje horas planeadas', field: 'porcentaje_horas', width: '12%', enableHiding: false },
				{ name: 'Horas ejec.', displayName: 'Horas ejecutadas', field: 'total_horas_executed', width: '8%', enableHiding: false },
				{ name: 'Porcentaje horas ejec.', displayName: 'Porcentaje horas ejecutadas', field: 'porcentaje_horas_executed', width: '12%', enableHiding: false },
			],
			//
			onRegisterApi: function (gridApi) {
				$scope.gridApi = gridApi
				$scope.gridApi.treeBase.on.rowExpanded($scope, function (row) {
				})
			},
		}

		getTableData()

		function getTableData () {
			$scope.isLoading = true
			let data = []

			$scope.gridOptions.data = []
			let params = {
				workplanId: summaryVm.workplanId,
				teacherId : summaryVm.teacherId,
			}
			let total_horas = 0, total_horas_executed = 0

			WorkPlanSrv.summary.getDataGrid(params).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					summaryVm.workplanTeacherId = response.workplanteacherId
					summaryVm.userId = response.userId

					if (response.userIdentification && response.userIdentification.length > 0) {
						//$scope.picture = getFullpathUserImage(response.userIdentification)
						$scope.picture = response.profilePicture + '?1' + Math.random()
					}

					$scope.notPicture = require('../../../../../../images/unknown.png')

					for (let i in response.data) {
						let val = data.length

						data.push({
							$$treeLevel         : 0,
							ds_submodule        : response.data[i].ds_submodule,
							total_horas         : response.data[i].total_horas,
							total_horas_executed: response.data[i].total_horas_executed,
						})
						let countHoursTotal = 0, countHoursExecTotal = 0

						for (let x in response.data[i].job_submodule) {
							let valSubmodule = data.length

							data.push({
								$$treeLevel         : 1,
								total_horas         : response.data[i].job_submodule[x].total_horas,
								total_horas_executed: response.data[i].job_submodule[x].total_horas_executed,
								ds_activity_type    : response.data[i].job_submodule[x].ds_activity_type,
							})
							let countHours = 0
							let countHoursExec = 0

							for (let j in response.data[i].job_submodule[x].job_activity_type) {
								countHours = countHours + response.data[i].job_submodule[x].job_activity_type[j].total_horas
								countHoursExec = countHoursExec + response.data[i].job_submodule[x].job_activity_type[j].total_horas_executed

								data.push({
									total_horas         : response.data[i].job_submodule[x].job_activity_type[j].total_horas,
									total_horas_executed: response.data[i].job_submodule[x].job_activity_type[j].total_horas_executed,
									ds_activity         : response.data[i].job_submodule[x].job_activity_type[j].ds_activity,
									isStrategicTracing  : response.data[i].job_submodule[x].job_activity_type[j].isStrategicTracing,
									status              : response.data[i].job_submodule[x].job_activity_type[j].status,

									isReviewed         : response.data[i].job_submodule[x].job_activity_type[j].isReviewed,
									isApproved         : response.data[i].job_submodule[x].job_activity_type[j].isApproved,
									isAccept           : response.data[i].job_submodule[x].job_activity_type[j].isAccept,
									isExecution        : response.data[i].job_submodule[x].job_activity_type[j].isExecution,
									isReviewedExecution: response.data[i].job_submodule[x].job_activity_type[j].isReviewedExecution,
									isEvaluation       : response.data[i].job_submodule[x].job_activity_type[j].isEvaluation,

									inReview         : summaryVm.inReview,
									inApproval       : summaryVm.inApproval,
									inExecution      : summaryVm.inExecution,
									inReviewExecution: summaryVm.inReviewExecution,
									inEvaluation     : summaryVm.inEvaluation,

								})
							}
							data[valSubmodule].total_horas = countHours
							data[valSubmodule].total_horas_executed = countHoursExec
							countHoursTotal = countHoursTotal + countHours
							countHoursExecTotal = countHoursExecTotal + countHoursExec
						}
						data[val].total_horas = countHoursTotal
						data[val].total_horas_executed = countHoursExecTotal
					}
					$scope.isLoading = false
					$scope.gridOptions.data = data
				}

				for (let i in data) {
					if (data[i].$$treeLevel == 0) {
						if (typeof data[i].total_horas !== 'undefiend') {
							total_horas += data[i].total_horas
						}

						if (typeof data[i].total_horas_executed !== 'undefiend') {
							total_horas_executed += data[i].total_horas_executed
						}
					}
				}
				for (let i in data) {
					if (data[i].$$treeLevel == 0) {
						data[i].porcentaje_horas = (total_horas > 0 ? (data[i].total_horas * 100 / total_horas) : 0).toFixed(2) + '%'
						data[i].porcentaje_horas_executed = (total_horas_executed > 0 ? data[i].total_horas_executed * 100 / total_horas_executed : 0).toFixed(2) + '%'
					}
				}

				summaryVm.hours_planned_detail = total_horas
				summaryVm.hours_executed_detail = total_horas_executed

				// summaryVm.headerPage.hours_planned=total_horas;
				// summaryVm.headerPage.hours_executed=total_horas_executed;
				//  console.log(total_horas+'---t0tt---'+total_horas_executed)
			}, (err) => {
				ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function setHeader () {
			return {
				teacherId   : summaryVm.headerPage.id_teacher,
				workplanId  : summaryVm.workplanId,
				textStage   : summaryVm.textStage,
				userId      : user.id,
				currentStage: currentStage,
			}
		}

		// Modal
		function showModal (isReviewAndApproval = false) {
			summaryVm.headerModal.userId = summaryVm.userId
			summaryVm.headerModal.teacherName = summaryVm.headerPage.teacherName
			summaryVm.headerModal.isReviewAndApproval = isReviewAndApproval
			summaryVm.headerModal.textStage = (isReviewAndApproval && (summaryVm.inReview || summaryVm.inReviewExecution)) ? 
				summaryVm.textStageUnified : summaryVm.headerModal.textStage
			summaryVm.headerModal.isReviewAndApproval
			WorkPlanModalSrv.setVariable(summaryVm.headerModal)

			if (summaryVm.inApproval || summaryVm.inEvaluation || summaryVm.inReviewExecution) {
				// return summaryVm.headerModal > 0
			}

			if (GlobalConfig.userRolesIds.approver == roleId && inEvaluation == true) {
				WorkPlanModalSrv.endStage()
			} else if (GlobalConfig.userRolesIds.teacher == roleId && inExecution == true) {
				$state.go('evaluations.teacherSelfAssessment')   
			} else {
				WorkPlanModalSrv.endStage()
			}
		}

		function setHeaderApproval () {
			let post = {
				teacherId : summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				stageId   : GlobalConfig.workplanIdStages.approval,
			}

			return WorkPlanSrv.getReprovedActivities.get(post).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					summaryVm.headerModal.count = dataReturn.data.toApprove
					summaryVm.headerModal.toReviewed = dataReturn.data.noTouched
					summaryVm.headerModal.allAct = dataReturn.data.allAct
					summaryVm.headerModal.strategic = dataReturn.data.forStrategicTracingOn
				}
			})
		}

		function setHeaderEvaluation () {
			let post = {
				teacherId : summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				stageId   : GlobalConfig.workplanIdStages.evaluation,
			}

			return WorkPlanSrv.getReprovedActivities.get(post).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					summaryVm.headerModal.toReviewed = dataReturn.data.noTouched
				}
			})
		}

		function setReviewExecutionEvaluation () {
			let post = {
				teacherId : summaryVm.headerPage.id_teacher,
				workplanId: summaryVm.workplanId,
				stageId   : GlobalConfig.workplanIdStages.reviewExecution,
			}

			return WorkPlanSrv.getReprovedActivities.get(post).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					summaryVm.headerModal.toReviewed = dataReturn.data.noTouched
				}
			})
		}

		function showWarning () {
			const header = {
				teacherId         : summaryVm.teacherId,
				workplanId        : summaryVm.workplanId,
				textStage         : summaryVm.textStage,
				evaluatorId       : user.id,
				currentStage      : currentStage,
				workplanteacherId : summaryVm.workplanTeacherId,
				isReviewerApprover: summaryVm.isReviewerApprover,
			}
			const headerDump = {
				workplanteacherId: summaryVm.workplanTeacherId,
			}

			WorkPlanModalSrv.setVariable(header)

			return $mdDialog.show({
				controller         : 'warningApprovalCtrl',
				controllerAs       : 'warningCtrl',
				template           : require('./modals/warningApproval.html'),
				clickOutsideToClose: true,
			}).then((response) => {
				if (response) {
					if (summaryVm.inApproval || summaryVm.inReview) {
						setDumpInformation(headerDump).then(() => approveAll(header))
					} else if (summaryVm.inEvaluation || summaryVm.inReviewExecution) {
						setDumpInformation(headerDump).then(() => approvalAllEvaluation(header))
					}
				}
			})
		}

		function approvalAllEvaluation (datos) {
			let params = {
				workplanTeacherId : datos.workplanteacherId,
				evaluatorId       : datos.evaluatorId,
				isReviewerApprover: datos.isReviewerApprover,
			}

			WorkPlanSrv.summary.approvalAllEvaluation(params).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					// Despues de guardar los cambios, recargar el ui-grid
					getTeacherInfo()
					getTableData()

					// El conteo que habilita "Finalizar" debe leer la etapa actual:
					// revisión de la ejecución usa is_execution; evaluación usa is_accept.
					if (summaryVm.inReviewExecution) {
						setReviewExecutionEvaluation()
					} else {
						setHeaderEvaluation()
					}

					ngNotify.set('Actividades Aprobadas Exitosamente!', 'success')
				}
			}, (err) => {
				ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function setDumpInformation (header) {
			return WorkPlanSrv.setDumpInformation.post(header).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					// Despues de guardar los cambios, recargar el ui-grid
					getTableData()
					ngNotify.set('Actividades Aprobadas Exitosamente!', 'success')
				}

				return true
			}, (err) => {
				ngNotify.set('Imposible conectar con el servicio', 'error')

				return false
			})
		}

		function approveAll (datos) {
			/* let params = {
        workplanTeacherId: datos.workplanteacherId,
        userId: user.id
      } */
			WorkPlanSrv.summary.approvalAll(datos).$promise.then((response) => {
				if (!response.status) {
					ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					// Despues de guardar los cambios, recargar el ui-grid
					getTeacherInfo()
					getTableData()
					setHeaderApproval()
					ngNotify.set('Actividades Aprobadas Exitosamente!', 'success')
				}
			}, (err) => {
				ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function showModalFeedback () {
			let post = {
				teacherId  : summaryVm.headerPage.id_teacher,
				workplanId : summaryVm.workplanId,
				teacherName: summaryVm.headerPage.teacher_name,
				userId     : summaryVm.userId,
			}

			WorkPlanSrv.getActivitiesNotReviewed.get(post).$promise.then((response) => {
				post.data = response.data
				WorkPlanModalSrv.setVariable(post)
				WorkPlanModalSrv.feedbackReviewed().then((promise) => {
				})
			})
		}

		function showEndStageButton () {
			if (summaryVm.inReviewExecution) {
				return summaryVm.executionFinish === 1
			} else {
				return true
			}
		}

		function getGeneralsWorkplan () {
			return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: summaryVm.teacherId }).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					summaryVm.workplanIdStages = dataReturn.data.wokplanTeacherStatus[0].stageId
					summaryVm.feedback = dataReturn.data.wokplanTeacherStatus[0].isFeedback
					summaryVm.isState = dataReturn.data.wokplanTeacherStatus[0].isState
					summaryVm.selfEvaluation = dataReturn.data.wokplanTeacherStatus[0].selfEvaluation
				}
			})
		}

		function getFullpathUserImage (identification) {
			return GlobalConfig.azureProfilePicturePath + identification + '.jpg1=' + Math.random()
		}

		function isStageFinished () {
			if (Validations.isConsultant(roleId))
				return true
			else if (summaryVm.inReview) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.review
			} else if (summaryVm.inApproval) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.approval
			} else if (summaryVm.inReviewExecution) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.reviewExecution
			} else if (summaryVm.evaluationFinish) {
				return summaryVm.workplanIdStages != GlobalConfig.workplanIdStages.evaluation
			}
		}

		// accordian start
		$scope.oneAtATime = true
		// accordian end 

		// question 11 grid options
		$scope.q11GridOptions = {

			rowHeight: 36,

			data: [
				{
					Respuestas: 'Lideranzgo',
					Cantidad  : '7',
					Porcentaje: '7%',
				},
				{
					Respuestas: 'Autonomia',
					Cantidad  : '15',
					Porcentaje: '15%',
				},
				{
					Respuestas: 'Trabajo en equipo',
					Cantidad  : '10',
					Porcentaje: '10%',
				},
			],

		}

		// reflexiones de portafolio evidencias model
		function reflexionesDePortafolioEvidenciasModel() {
			var confirm = $mdDialog.confirm({
				controller  : 'reflexionesDePortafolioEvidenciasController',
				controllerAs: 'reflexionesDePortafolioEvidencias',
				template    : require('./evaluacionDeProfesoresTemplates/dialogs/reflexionesDePortafolioEvidencias.html'),
				locals      : {
				},
				animation          : true,
				parent             : angular.element(document.body),
				clickOutsideToClose: true,
			})

			$mdDialog.show(confirm).then(function() {

			})
		}
	}

}

SummaryCtrl.$inject = [ '$scope', 'WorkPlanModalSrv', '$stateParams', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', 'uiGridTreeViewConstants',
	'$http', '$window', '$cookies', 'Validations', 'WorkPlanSrv', 'GlobalConfig', 'ReviewSrv', 'ngNotify', '$state', 'LOCAL_ENV_CONSTANT' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/summaryCtrl.js